import { useEffect } from 'react';

/**
 * Sends a "ready" postMessage to the parent or opener window once on mount,
 * signalling to the host environment that the application has loaded.
 */
export function useReadySignal(): void {
    useEffect(() => {
        const target = window.opener || window.parent;
        target?.postMessage('ready', '*');
    }, []);
}
